import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlockedComponent } from './components/blocked/blocked.component';
import { FbsharesuccessComponent } from './components/fb-share/fbsharesuccess/fbsharesuccess.component';
import { FeedbackSuccessComponent } from './components/feedback-success/feedback-success.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { HomeComponent } from './components/home/home.component';
import { NickNameComponent } from './components/nick-name/nick-name.component';
import { PlayComponent } from './components/play/play.component';
import { RankingComponent } from './components/ranking/ranking.component';
import { CookieComponent } from './components/shared/support/cookie/cookie.component';
import { UpdateAddressSuccessComponent } from './components/update-address-success/update-address-success.component';
import { UpdateAddressComponent } from './components/update-address/update-address.component';
import { UploadComponent } from './components/upload/upload.component';
import { WinnersComponent } from './components/winners/winners.component';
import { CreateTournamentComponent } from './components/create-tournament/create-tournament.component';
import { TournamentListComponent } from './components/tournament-list/tournament-list.component';
import { JoinTournamentComponent } from './components/join-tournament/join-tournament.component';
import { SupportRulesComponent } from './components/shared/support/support-rules/support-rules.component';
import { SupportPolicyComponent } from './components/shared/support/support-policy/support-policy.component';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { CaptureImageComponent } from './components/capture-image/capture-image.component';
import { CashbackComponent } from './components/cashback/cashback.component';
import { EmailReminderComponent } from './components/shared/email-reminder/email-reminder.component';
import { ReportComponent } from './components/report/report.component';



const routes: Routes = [
  { path: '', pathMatch: 'full', component: HomeComponent },
  // { path: '*', component: ComingSoonComponent },
  // { path: '**', component: ComingSoonComponent },
  // { path: '', component: LandingComponent },
  { path: 'home', component: HomeComponent },
  { path: 'capturenickname', component: NickNameComponent },
  { path: 'ranking', component: RankingComponent },
  { path: 'play', component: PlayComponent },
  { path: 'winners', component: WinnersComponent },
  { path: 'receipt-upload', component: UploadComponent },
  { path: 'fbShareSuccess', component: FbsharesuccessComponent },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'cookie', component: CookieComponent },
  { path: 'feedback/success', component: FeedbackSuccessComponent },
  { path: 'updateAddress/:id', component: UpdateAddressComponent },
  { path: 'updateSuccess', component: UpdateAddressSuccessComponent },
  { path: 'blocked', component: BlockedComponent },
  { path: 'rules', component: SupportRulesComponent },
  { path: 'comingsoon', component: ComingSoonComponent },
  { path: 'cashback', component: CashbackComponent },
  { path: 'policy', component: SupportPolicyComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'captureImage', component: CaptureImageComponent },
  { path: 'reminder', component: EmailReminderComponent },
  { path: 'report', component: ReportComponent },


];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 100]
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
